export const BASE_URL = 'https://api.sojiapps.com/api/v1';
export const GOOGLE_MAP_API_KEY = 'AIzaSyCUomuiEBLH7rFCrtmGuYDkLXeRN9QLaUU';
export const PLACEHOLDER_IMAGE =
  'https://res.cloudinary.com/vicman/image/upload/v1652815262/SOJI/Every/vbhvhamprmfmix8n8uug.png';
